import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../../chunks/tslib.es6.js";
import e from "../../core/Logger.js";
import { isAbortError as s } from "../../core/promiseUtils.js";
import { on as o } from "../../core/watchUtils.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";

var i = function i(_i2) {
  var c = /*#__PURE__*/function (_i) {
    _inherits(c, _i);

    var _super = _createSuper(c);

    function c() {
      _classCallCheck(this, c);

      return _super.apply(this, arguments);
    }

    _createClass(c, [{
      key: "initialize",
      value: function initialize() {
        var _this = this;

        this.handles.add(o(this, "layer", "refresh", function (r) {
          _this.doRefresh(r.dataChanged).catch(function (r) {
            s(r) || e.getLogger(_this.declaredClass).error(r);
          });
        }), "RefreshableLayerView");
      }
    }]);

    return c;
  }(_i2);

  return r([t()], c.prototype, "layer", void 0), c = r([a("esri.layers.mixins.RefreshableLayerView")], c), c;
};

export { i as RefreshableLayerView, i as default };